import { getCsrfValue } from "../../api/ApiHelper";

import { resolveApiUrl } from "../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/store-finder/sendWishlist");

export const sendWishlist = (data: {
  wishlistId: string;
  entryIds: string[];
  salesPartnerCode: string;
  salesPartnerMessage: string;
}): Promise<any> => {
  return fetch(apiUrl, {
    body: JSON.stringify(data),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  }).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response;
    }
  });
};
